module.exports = __webpack_public_path__ + "img/slide-8.7b94acb9.jpg";